export default __webpack_public_path__ + "static/media/text1.2f219bea.glb";